
export const selectRow = (
  setSelectedRowKeys,
  setSelectedRow,
  selectedRow,
  selectedRowKeys,
  record,
  selected
) => {
  console.log(record, "recordd")
  const updatedAllSelectedRow = [...selectedRow];
  console.log(updatedAllSelectedRow, "updatedAllSelectedRow")
  const updatedSelectedRowKeys = [...selectedRowKeys];
  console.log(updatedSelectedRowKeys, "updatedSelectedRowKeys")

  if (selected === true) {
    updatedAllSelectedRow.push(record);
    updatedSelectedRowKeys.push(record.key);
  } else {
    const index = updatedAllSelectedRow.findIndex(
      (item) => item.key === record.key
    );
    if (index > -1) {
      updatedAllSelectedRow.splice(index, 1);
      const keyIndex = updatedSelectedRowKeys.findIndex(
        (key) => key === record.key
      );
      if (keyIndex > -1) {
        updatedSelectedRowKeys.splice(keyIndex, 1);
      }
    }
  }
  setSelectedRowKeys(updatedSelectedRowKeys);
  setSelectedRow(updatedAllSelectedRow);
};

export const selectAllRows = (
  setSelectedRowKeys,
  setSelectedRow,
  selectedRow,
  selectedRowKeys,
  changeRows,
  selected
) => {
  const updatedAllSelectedRow = selected
    ? [...selectedRow, ...changeRows]
    : selectedRow.filter((row) => !changeRows.some((changeRow) => changeRow.key === row.key));

  const updatedSelectedRowKeys = selected
    ? [...selectedRowKeys, ...changeRows.map((row) => row.key)]
    : selectedRowKeys.filter((key) => !changeRows.some((row) => row.key === key));

  setSelectedRowKeys([...new Set(updatedSelectedRowKeys)]);
  setSelectedRow([...new Set(updatedAllSelectedRow)]);
};

export const dataCount = (statusText, filteredData = []) => {
  return Object.values(statusText).reduce((acc, status) => {
    if (status === "all") {
      acc[status] = filteredData?.length
    } else {
      acc[status] = filteredData?.filter((f) => f.status === status).length || 0;
    }
    return acc;
  }, {});
};

export const dataTableSorting = (paginatedData) => {
  const data = paginatedData.sort((a, b) => {
    const updatedAtA = a.updatedAt || a.createdAt || 0;
    const updatedAtB = b.updatedAt || b.createdAt || 0;
    return updatedAtB - updatedAtA;
  });
  return data;
};

export const datasourceFilter = (dataSource, key) => {
  let data = [];
  if (key === "all") {
    data = dataSource;
  } else {
    data = dataSource?.filter((d) => d.status === key);
  }

  return data;
};

// export const dataCount2 = (statusText, filteredData) => {
//   return Object.values(statusText).reduce((acc, status) => {
//     acc[status] = filteredData?.[status]?.length || 0;
//     return acc;
//   }, {});
// };

// export const dataFilter = (statusText, arr) => {
//   return Object.values(statusText).reduce((acc, status) => {
//     if (status === "all") {
//       acc[status] = dataTableSorting(arr);
//     } else {
//       const data = arr.filter((f) => f.status === status);
//       acc[status] = dataTableSorting(data);
//     }
//     return acc;
//   }, {});
// };

// export const dataFilterPayroll = (statusText, arr) => {
//   return Object.values(statusText).reduce((acc, status) => {
//     if (status === "all") {
//       const data = arr.filter((f) => f.status !== 2);
//       acc[status] = dataTableSorting(data);
//     } else {
//       const data = arr.filter((f) => f.status === status);
//       acc[status] = dataTableSorting(data);
//     }
//     return acc;
//   }, {});
// };

// export const dataSoureTable = (arr, statusText) => {
//   return Object.values(statusText).reduce((acc, status) => {
//     if (status === "all") {
//       acc[status] = arr;
//     } else {
//       const data = arr?.filter((f) => f.status === status);
//       acc[status] = data;
//     }
//     return acc;
//   }, {});
// };
